export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WA_KARINA = "34691536518";
export const WA_CARMELINA = "34630803769";
export const wa = (phone, msg) => `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`;
export const waKarina = (tema) => wa(WA_KARINA, `Hola Karina, quiero reservar/consultar por ${tema}.`);
export const WA_VALORACION = wa(WA_KARINA, "Hola Karina, quiero reservar mi valoración gratuita.");

export const EMAIL = "infokarimendezmk@gmail.com";
export const ADDRESS_1 = "Calle Ruiz de Padrón 107, Edificio Las Creces, Local 4";
export const ADDRESS_2 = "San Sebastián de La Gomera, 38800 · Islas Canarias, España";
export const HOURS = [
  ["Lunes a viernes", "9:30–13:00 · 15:00–18:00"],
  ["Sábados y domingos", "Cerrado"],
];
export const SOCIALS = [
  { name: "Instagram", handle: "@karinamendezstudio", url: "https://instagram.com/karinamendezstudio" },
  { name: "TikTok", handle: "@karimendezmk", url: "https://tiktok.com/@karimendezmk" },
  { name: "Facebook", handle: "Karina Méndez MK", url: "https://facebook.com/karinamendezmk" },
];
export const NAV = [
  { to: "/", label: "Inicio", id: "inicio" },
  { to: "/sobre-mi", label: "Sobre mí", id: "sobre-mi" },
  { to: "/tecnica-nagi", label: "Técnica NAGI", id: "tecnica-nagi" },
  { to: "/academia", label: "Academia", id: "academia" },
  { to: "/servicios", label: "Servicios", id: "servicios" },
  { to: "/mi-studio", label: "Mi Studio", id: "mi-studio" },
  { to: "/tienda", label: "Tienda", id: "tienda" },
  { to: "/contacto", label: "Contacto", id: "contacto" },
];
export const MAPS_EMBED =
  "https://www.google.com/maps?q=Calle%20Ruiz%20de%20Padr%C3%B3n%20107%2C%20San%20Sebasti%C3%A1n%20de%20La%20Gomera&output=embed";

export const TESTIMONIALS = [
  {
    initials: "JG",
    name: "Joselin González",
    text: "Muy buen servicio, me encantan las uñas y la micropigmentación de cejas. Llevo tiempo viniendo y lo recomiendo.",
  },
  {
    initials: "AR",
    name: "Ana Reyes Gutiérrez Hernández",
    text: "Tengo años viniendo a este Studio y estoy demasiado contenta con el servicio, la atención y la calidad de todo.",
  },
  {
    initials: "SY",
    name: "Stephany Yeguez",
    text: "El mejor lugar para consentirte y ponerte bella, la mejor manicurista de toda La Gomera. Sin duda 100% recomendada.",
  },
];

export const SERVICE_GROUPS = [
  {
    id: "cejas-labios",
    title: "Cejas y Labios",
    items: [
      {
        id: "valoracion",
        name: "Valoración gratuita",
        price: "Gratis",
        desc: "¿Tienes ganas pero también dudas? Es normal — es tu rostro, y quieres estar segura antes de dar el paso. Por eso, antes de cualquier procedimiento, nos sentamos juntas: te cuento cómo funciona mi técnica en tu piel, resolvemos cada duda, y decides con total tranquilidad. Sin compromiso, sin costo.",
      },
      {
        id: "nagi-brows",
        name: "Micropigmentación de cejas — NAGI Brows",
        price: "desde 280€",
        desc: "El miedo más común es uno solo: “¿y si me queda como tatuaje?” Por eso diseño cada ceja pensando en tu rostro y tu piel — no es para todas igual. El resultado es tuyo, no de nadie más, y está pensado especialmente para pieles sensibles al sol.",
        photos: ["/images/nagi-brows.jpg", "/images/nagi-brows-antes-2.jpg", "/images/nagi-brows-despues-2.jpg", "/images/nagi-brows-antes-3.jpg", "/images/nagi-brows-despues-3.jpg", "/images/nagi-brows-espejo.jpg", "/images/nagi-brows-clienta.webp", "/images/nagi-brows-arte.jpg"],
      },
      {
        id: "nagi-lips",
        name: "Micropigmentación de labios — NAGI Lips",
        price: "desde 300€",
        desc: "Quieres más color y definición, pero con naturalidad, sin que se vea muy marcado. Por eso te ofrezco un resultado que parte de la forma y el tono que ya tienes, para que se vea hermoso, definido y con vida.",
        photos: ["/images/nagi-lips.webp", "/images/nagi-lips-2.webp", "/images/nagi-lips-antes-despues.webp"],
      },
      {
        id: "hilo",
        name: "Depilación con hilo",
        price: "cejas desde 10€ · labio desde 5€ · rostro desde 25€",
        desc: "Esta técnica la elegí desde mis inicios porque respeta tu piel y deja un resultado limpio, preciso, desde el primer momento — sin irritación, sin vuelta atrás que lamentar.",
        photos: ["/images/depilacion-hilo.jpg"],
      },
      {
        id: "henna",
        name: "Depilación con hilo en cejas + henna",
        price: "desde 15€",
        desc: "¿No estás lista para algo permanente? Perfecto, no tienes que estarlo. Aquí puedes ver un diseño real en tus propias cejas, con color y forma. Es la forma más segura de “probarte” antes de decidir.",
      },
      {
        id: "laminado",
        name: "Laminado de cejas (con tinte / sin tinte)",
        price: "desde 40€",
        desc: "Imagina despertar con las cejas ya peinadas, con cuerpo, sin tener que arreglarlas cada mañana. Eso es lo que dura semanas con este servicio — y si quieres ir un paso más allá, el tinte refuerza el color para un efecto aún más definido.",
        photos: ["/images/laminado-lifting.jpg"],
      },
    ],
  },
  {
    id: "pestanas",
    title: "Pestañas",
    items: [
      {
        id: "lifting",
        name: "Lifting de pestañas (con opción de tinte)",
        price: "desde 40€",
        desc: "Sin pestañas postizas, sin extensiones que mantener — solo las tuyas, con una curva que abre la mirada y les da volumen natural, sin agredir ni dañar tu pestaña. Si quieres ir un paso más, sumamos tinte para no depender de la máscara ni un solo día.",
        photos: ["/images/laminado-lifting.jpg"],
      },
    ],
  },
  {
    id: "manos",
    title: "Manos",
    items: [
      {
        id: "manicura-rusa",
        name: "Manicura rusa PRO",
        price: "45€",
        desc: "Uñas perfectas por mucho más tiempo: una nivelación impecable, uniforme, sin imperfecciones, con esmaltado limpio desde la cutícula y diseños personalizados a tu gusto.",
        photos: ["/images/manicura-1.jpg", "/images/manicura-2.jpg"],
      },
    ],
  },
];

export const COMPLEMENTA = [
  {
    id: "pedicura-rusa",
    name: "Pedicura rusa al seco",
    desc: "¿Conoces nuestra innovación en pedicura? Somos pioneras en La Gomera en ofrecer este servicio exclusivo: instrumentos especiales para el retiro de durezas, cutícula y sequedad con el pododisco — una experiencia mucho más precisa que la pedicura tradicional. Disfruta del vapor de ozono, el calor de las toallas calientes y una limpieza realmente profunda. Cierra tu experiencia con el esmalte de tu elección — tradicional o semipermanente. Porque tú mereces ser consentida.",
  },
  {
    id: "drenaje",
    name: "Drenaje linfático",
    desc: "¿Sientes las piernas pesadas o cansadas al final del día? Es una señal común de mala circulación o acumulación de líquidos — y tiene solución. Con esta técnica activamos tu sistema linfático, ayudando a reducir esa sensación de hinchazón y mejorando tu bienestar general, sesión tras sesión.",
  },
  {
    id: "maderoterapia",
    name: "Maderoterapia corporal",
    desc: "Con instrumentos de madera diseñados específicamente para moldear el cuerpo, activamos tu circulación sanguínea y linfática, ayudamos a reducir medidas y mejoramos la textura de tu piel — todo sin dolor ni hematomas. Una técnica innovadora para quienes buscan resultados visibles de forma natural.",
  },
  {
    id: "masaje",
    name: "Masaje relajante con maderoterapia",
    desc: "Para cuando lo que necesitas es desconectar. Combinamos relajación pura con los beneficios de la maderoterapia en piernas, cuello y espalda — cuidando tu cuerpo mientras le das a tu mente el descanso que merece.",
  },
];

export const CAMINO_NAGI = ["Piel", "Diseño", "Técnica", "Maniobra", "Criterio", "Confianza"];
